import { locales } from "./locales";

const config = {
  DEFAULT_LOCALE: locales.EN,
  SUPPORTED_LOCALES: Object.values(locales),
};

export { config };
